// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-spin {
  margin-left: 23px;
}

span.refresh {
  padding-bottom: 10px;
}

.spinner {
  padding-bottom: 10px;
  margin-right: 16px;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

.table-responsive table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-responsive table th {
  text-align: left;
}
.table-responsive table th span.sortby {
  top: 5px;
}
.table-responsive table input {
  font: inherit;
}
.table-responsive table input[type=checkbox] {
  position: absolute;
  margin-left: -20px;
}
.table-responsive .form-group {
  margin-bottom: 15px;
}
.table-responsive label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}

.table-striped thead tr:first-child th {
  background: #464646;
  color: #fff;
  padding: 10px 10px 5px;
  white-space: nowrap;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-striped > tbody tr:first-child th {
  background: #464646;
  color: #fff;
  padding: 10px 10px 5px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-downloads/account-downloads.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;AACD;;AACA;EACC,oBAAA;AAED;;AAAA;EACE,oBAAA;EACA,kBAAA;AAGF;;AADA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,yBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAJA;EACE,yBAAA;EACA,cAAA;AAOF;;AALA;EACE,eAAA;AAQF;;AAAC;EACC,WAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACE,iBAAA;AAGJ;AADE;EACC,gBAAA;AAGH;AADM;EACE,QAAA;AAGR;AACE;EACI,aAAA;AACN;AACM;EACE,kBAAA;EACA,kBAAA;AACR;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;;AAcM;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AAXR;AAkBE;EACC,yBAAA;AAhBH;AAqBM;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AAnBR","sourcesContent":[".fa-spin{\n\tmargin-left: 23px;\n}\nspan.refresh{\n\tpadding-bottom: 10px;\n}\n.spinner{\n  padding-bottom: 10px;\n  margin-right: 16px;\n}\n::ng-deep #holder > li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n::ng-deep #holder > li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n::ng-deep #holder > li.separator:before {\n  content: '...';\n}\n::ng-deep #holder > li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n::ng-deep #holder > li[data-page]:hover {\n  cursor: pointer;\n}\n\n\n// Table Styling\n\n.table-responsive {\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tmargin-bottom: 20px;\n\t\tbackground-color: transparent;\n\t\tborder-collapse: collapse;\n    border-spacing: 0;\n\n\t\tth {\n\t\t\ttext-align: left;\n\n      span.sortby {\n        top: 5px;\n      }\n    }\n\n\t\tinput {\n      font: inherit;\n\n      &[type=checkbox]{\n        position: absolute;\n        margin-left: -20px;\n      }\n\t\t}\n\t}\n\n  .form-group{\n    margin-bottom: 15px;\n  }\n\n  label {\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: 700;\n  }\n}\n\n\n.table-striped {\n\n  thead {   \n\n    tr:first-child {\n\n      th {\n        background: #464646;\n        color: #fff;\n        padding: 10px 10px 5px;\n        white-space: nowrap;\n      }\n    }\n  }\n\n\t& > tbody {\n\n\t\t& > tr:nth-of-type(odd) {\n\t\t\tbackground-color: #f9f9f9;\n\t\t}\n\n    tr:first-child {\n\n      th {\n        background: #464646;\n        color: #fff;\n        padding: 10px 10px 5px;\n        white-space: nowrap;\n      }\n    }\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
